<template>
    <div>

        <home-header :title="i18n('Main')"></home-header>

        <home-grid schedules users dispatching sales pricing settings transporters reports profile logs></home-grid>

    </div>
</template>

<script>
    import HomeGrid from "./HomeGrid";
    import HomeHeader from "./HomeHeader";

    export default {
        components: {
            HomeHeader,
            HomeGrid,
        }
    }
</script>

<style></style>
